import { useSelector } from 'react-redux';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { PromoTariffsSelectors } from 'reactApp/modules/promoTariffs/promoTariffsBillingData.adapter';
import type { RootState } from 'reactApp/store';

export const useSubscription = ({ id }: { id: string }) => {
    const basicSubscription = useSelector(BillingDataSelectors.getBasicSubscription);
    const subscription = useSelector((state: RootState) => BillingDataSelectors.getSubscriptionsById(state, id));
    const promoSubscriptions = useSelector((state: RootState) => PromoTariffsSelectors.getPromoById(state, id));

    if (id === 'base') {
        return basicSubscription;
    }

    return subscription || promoSubscriptions;
};
